import { render, staticRenderFns } from "./MenuAdminManagement.vue?vue&type=template&id=68d03614&scoped=true"
import script from "./MenuAdminManagement.vue?vue&type=script&lang=js"
export * from "./MenuAdminManagement.vue?vue&type=script&lang=js"
import style0 from "./MenuAdminManagement.vue?vue&type=style&index=0&id=68d03614&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d03614",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68d03614')) {
      api.createRecord('68d03614', component.options)
    } else {
      api.reload('68d03614', component.options)
    }
    module.hot.accept("./MenuAdminManagement.vue?vue&type=template&id=68d03614&scoped=true", function () {
      api.rerender('68d03614', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/MenuAdminManagement.vue"
export default component.exports